import { Chip } from '@mui/material';
import clsx from 'clsx';
import React, { useState } from 'react';
import styles from './GlobalSearchEntityFilter.module.scss';
import useAnalyticsTracker from '../../../analytics/hooks/useAnalyticsTracker';
import { GlobalSearchTracking } from '../../constants/global-search-tracking';
import { useGlobalSearchContext } from '../../hooks/useGlobalSearchContext';


export function GlobalSearchEntityFilter() {
  const { filterChips, applyFilter } = useGlobalSearchContext();

  const [selectedFilters, setSelectedFilters] = useState<string[]>([]);

  const { eventTrack } = useAnalyticsTracker();

  const onFilterClick = (filter: string) => {
    const index = selectedFilters.findIndex((f) => f === filter);

    const _newFilters = [...selectedFilters];

    if (index >= 0) {
      _newFilters.splice(index, 1);
    } else {
      _newFilters.push(filter);
    }

    eventTrack({
      action: GlobalSearchTracking.TRACKER_GLOBAL_ENTITY_FILTERS_APPLIED,
      properties: {
        filters: _newFilters.join(',')
      }
    });

    setSelectedFilters(_newFilters);

    applyFilter(_newFilters);
  };

  const isSelected = (filter: string) => selectedFilters.findIndex((f) => f === filter) >= 0;

  return (
    <>
      {filterChips.map((f) => (
        <Chip
          key={f.value.toString()}
          className={clsx(styles.filterChip, 'keyboard-nav-item', isSelected(f.value) && styles.selectedChip)}
          label={<span className={clsx(styles.filterText, 'text-medium')}>{f.label}</span>}
          clickable
          tabIndex={0}
          data-id={`${f.value}-filter`}
          skipFocusWhenDisabled
          onClick={(e) => {
            onFilterClick(f.value);
            e.stopPropagation();
            e.currentTarget.blur();
          }}
        />
      ))}
    </>
  );
}
